import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, Thumbs } from 'swiper/modules';

import { SWIPER_CONFIG } from './config/swiper';

// Instantiate
const swiperElements = Array.from(document.querySelectorAll('.swiper'));

const initSwiper = (element) => {

    return new Swiper(element, {
        modules: [Navigation, Pagination, Autoplay, Thumbs],
        ...SWIPER_CONFIG,

        // Vanilla JS config
        ...{
            navigation: {
                nextEl: `#${element.id}-next`,
                prevEl: `#${element.id}-prev`,
            },
            pagination: {
                el: `#${element.id}-pagination`,
                clickable: true,
            },
        },
        ...(
            element.classList.contains('carousel--default') ? {
                slidesPerView: 1,
                spaceBetween: 16,
            } : {}
        ),
        ...(
            element.classList.contains('carousel--loop') ? {
                loop: true,
            } : {}
        ),
        // Specific configs
        ...(
            element.classList.contains('carousel--contacts') ? {
                slidesPerView: '1.5',
                spaceBetween: 10,
                grabCursor: true,
                centeredSlides: element.classList.contains('centered') ? true : false,
                loop: element.classList.contains('centered') ? true : false,
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    992: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                    },
                    1440: {
                        slidesPerView: 4,
                        spaceBetween: 20,
                    }
                },
            } : {}
        ),
        ...(
            element.classList.contains('carousel--top-five') ? {
                slidesPerView: 1,
                spaceBetween: 16,
                centerInsufficientSlides: true,
                grabCursor: false,
                breakpoints: {
                    600: {
                        slidesPerView: 2,
                    },
                    992: {
                        slidesPerView: 3,
                    },
                    1280: {
                        slidesPerView: 4,
                    },
                    1660: {
                        slidesPerView: 5,
                    }
                },
            } : {}
        ),
    });
};

swiperElements.forEach((element) => {
    initSwiper(element);
});
